import { extractFirstName } from "./email";
import { toPhoneNumberE164 } from "./telecom";
import { Maybe } from "./util/maybe";
export var PhoneType;
(function (PhoneType) {
    PhoneType[PhoneType["None"] = 1] = "None";
    PhoneType[PhoneType["Home"] = 2] = "Home";
    PhoneType[PhoneType["Work"] = 3] = "Work";
    PhoneType[PhoneType["MobileWork"] = 4] = "MobileWork";
    PhoneType[PhoneType["MobilePersonal"] = 5] = "MobilePersonal";
    PhoneType[PhoneType["Fax"] = 6] = "Fax";
    PhoneType[PhoneType["Other"] = 7] = "Other";
})(PhoneType || (PhoneType = {}));
export function GetPhoneTypeLabel(pt) {
    switch (pt) {
        case PhoneType.None:
            return "";
        case PhoneType.Home:
            return "Home";
        case PhoneType.Work:
            return "Work";
        case PhoneType.MobileWork:
            return "Mobile (Work)";
        case PhoneType.MobilePersonal:
            return "Mobile (Personal)";
        case PhoneType.Fax:
            return "Fax";
        case PhoneType.Other:
            return "Other";
        default:
            return "";
    }
}
export const singleLineAddress = (c) => {
    const address = c.address || c.address1;
    if (address && (c.city || c.state || c.zip)) {
        return address + ", " + formattedCityStateZip(c);
    }
    if (address) {
        return address;
    }
    return formattedCityStateZip(c);
};
export const formattedCityStateZip = (addressable) => {
    let retVal;
    const hasCity = addressable.city && addressable.city !== "";
    const hasState = addressable.state && addressable.state !== "";
    if (hasCity && hasState) {
        retVal = addressable.city + ", " + addressable.state;
    }
    else if (hasCity) {
        retVal = addressable.city ?? null;
    }
    else {
        retVal = addressable.state ?? null;
    }
    if (addressable.zip) {
        if (retVal) {
            if (hasCity && !hasState) {
                retVal += ",";
            }
            retVal += " ";
        }
        else {
            retVal = "";
        }
        retVal += addressable.zip;
    }
    return retVal;
};
export class Contact {
    constructor() {
        this.name = "";
        this.preferredName = "";
        this.address1 = "";
        this.address2 = "";
        this.city = "";
        this.state = "";
        this.zip = "";
        this.cellPhone = toPhoneNumberE164("");
        this.phone1 = toPhoneNumberE164("");
        this.phoneNumbers = [];
        this.email1 = "";
        this.email1OptOut = false;
        this.relationship = "";
        this.website = "";
        this.contactType = "";
        this.type = "";
        this.role = "";
        this.fax = toPhoneNumberE164("");
        this.contactNotes = "";
        this.clientPowerOfAttorney = "";
    }
    get contactTypeMaybe() {
        return Maybe.fromValue(this.contactType);
    }
    findPhone(p, pt) {
        return p.phoneNumberType === pt && !!p.number && p.number !== "";
    }
    get hasPhoneOther() {
        return this.phoneNumbers.some(p => this.findPhone(p, PhoneType.Other));
    }
    get hasPhoneMobilePersonal() {
        return this.phoneNumbers.some(p => this.findPhone(p, PhoneType.MobilePersonal));
    }
    get firstPhoneOther() {
        return this.phoneNumbers.find(p => this.findPhone(p, PhoneType.Other));
    }
    get firstPhoneMobilePersonal() {
        return this.phoneNumbers.find(p => this.findPhone(p, PhoneType.MobilePersonal));
    }
    static forEmail(email, name = "") {
        const c = new Contact();
        c.email1 = email;
        c.name = name;
        c.preferredName = extractFirstName(name);
        return c;
    }
    clone() {
        return Contact.clone(this);
    }
    static clone(source) {
        const theClone = new Contact();
        theClone.id = source.id || this.getLegacyId(source);
        theClone.name = source.name;
        theClone.preferredName = source.preferredName;
        theClone.address1 = source.address1;
        theClone.address2 = source.address2;
        theClone.city = source.city;
        theClone.state = source.state;
        theClone.zip = source.zip;
        theClone.cellPhone = toPhoneNumberE164(source.cellPhone);
        theClone.phone1 = toPhoneNumberE164(source.phone1);
        theClone.phoneNumbers = source.phoneNumbers ? [...source.phoneNumbers] : [];
        theClone.email1 = source.email1;
        theClone.email1OptOut = source.email1OptOut;
        theClone.role = source.role;
        theClone.website = source.website;
        theClone.contactType = source.contactType;
        theClone.type = source.type;
        theClone.relationship = source.relationship;
        theClone.fax = source.fax;
        theClone.contactNotes = source.contactNotes;
        theClone.clientPowerOfAttorney = source.clientPowerOfAttorney;
        theClone.dateAdded = source.dateAdded;
        return theClone;
    }
    static load(source) {
        return Contact.clone(source);
    }
    static fillDefaults(source) {
        const theClone = new Contact();
        theClone.id = source.id || this.getLegacyId(source);
        theClone.name = source.name || "";
        theClone.preferredName = source.preferredName || "";
        theClone.address1 = source.address1 || "";
        theClone.address2 = source.address2 || "";
        theClone.city = source.city || "";
        theClone.state = source.state || "";
        theClone.zip = source.zip || "";
        theClone.cellPhone = toPhoneNumberE164(source.cellPhone || "");
        theClone.phoneNumbers = source.phoneNumbers ? [...source.phoneNumbers] : [];
        theClone.phone1 = toPhoneNumberE164(source.phone1 || "");
        theClone.email1 = source.email1 || "";
        theClone.email1OptOut = source.email1OptOut || false;
        theClone.role = source.role || "";
        theClone.fax = toPhoneNumberE164(source.fax || "");
        theClone.website = source.website || "";
        theClone.contactType = source.contactType || "";
        theClone.type = source.type || "";
        theClone.relationship = source.relationship || "";
        theClone.contactNotes = source.contactNotes || "";
        theClone.clientPowerOfAttorney = source.clientPowerOfAttorney || "";
        return theClone;
    }
    static getLegacyId(contact) {
        const record = contact;
        return record["_id"];
    }
}
//# sourceMappingURL=contact.js.map